
import Typography from '@library/components/Atoms/Typography/Typography.vue'
import Links from '@library/components/Atoms/Link/Links.vue'
export default {
  name: 'navigatinColumn',
  components: {Links, Typography},
  data: () => ({}),
  props: {
    columns: [Object, Array]
  },
  methods: {
    isDouble(column) {
      return column.size === 'double'
    },
    filterObject(subsection, key) {
      const content = subsection.content?.link
      const texts = {
        linkRel: () => content?.rel || '',
        linkTitle: () => content?.title || content?.text || '',
        linkText: () => content?.text || '',
        linkUrl: () => content?.linkUrl || content?.urlExterna || '',
        linkIconKey: () => content?.icon?.key || 'nh-ic-category'
      }
      return texts[key]()
    }
  }
}
